// Duplicate SKU Detector — same UPC under multiple SKUs
import React, { useState, useEffect } from 'react';
import { api } from '../../App';

export default function DuplicateSKUs() {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(false);

  function load() {
    setLoading(true);
    api.get('/reports/duplicate-skus').then(r => { setData(r.data); setLoading(false); });
  }

  if (!data && !loading) return (
    <div className="empty-state">
      <div className="empty-icon">🔀</div>
      <button className="btn btn-primary" onClick={load}>Run Duplicate SKU Check</button>
    </div>
  );

  if (loading) return <div className="loading">Scanning for duplicates…</div>;

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div>
          {data.total === 0
            ? <span className="success-text">✓ No duplicate UPCs found</span>
            : <span className="error-text">⚠️ {data.total} UPC{data.total !== 1 ? 's' : ''} with multiple SKUs</span>
          }
        </div>
        <button className="btn btn-ghost" onClick={load}>🔄 Re-scan</button>
      </div>

      {data.total === 0 ? (
        <div className="empty-state"><div className="empty-icon">✅</div><div>All UPCs are unique</div></div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {data.duplicates.map(d => (
            <div key={d.upc} className="card" style={{ borderLeft:'3px solid var(--danger)' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                <div>
                  <span style={{ fontFamily:'monospace', fontWeight:700, fontSize:15, color:'var(--danger)' }}>UPC: {d.upc}</span>
                  <span style={{ fontSize:12, color:'var(--muted)', marginLeft:10 }}>{d.sku_count} SKUs share this UPC</span>
                </div>
                <span className="badge badge-error">Duplicate</span>
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {d.items.map(item => (
                  <div key={item.sku} style={{ display:'flex', alignItems:'center', gap:12, padding:'8px 10px', background:'rgba(255,77,109,.05)', borderRadius:6, fontSize:12 }}>
                    <span style={{ fontFamily:'monospace', color:'var(--accent2)', width:200, flexShrink:0 }}>{item.sku}</span>
                    <span style={{ flex:1, color:'var(--muted)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.title}</span>
                    <span style={{ color:'var(--accent)', fontFamily:'monospace', flexShrink:0 }}>📦 {item.location}</span>
                    <span style={{ color: item.quantity === 0 ? 'var(--danger)' : 'var(--accent2)', fontWeight:700, flexShrink:0 }}>Qty: {item.quantity}</span>
                  </div>
                ))}
              </div>

              <div style={{ marginTop:10, fontSize:11, color:'var(--muted)' }}>
                💡 These SKUs share the same UPC — verify they are truly different items (e.g. different condition or bin) or consolidate to avoid inventory drift.
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
